'use client';

import React, { useState, useEffect } from 'react';
import { SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/app-sidebar';
import { ChatHistoryDialog } from '@/components/chat-history-dialog';
import { useUser } from '@/contexts/user-context';
import { UserProfileHeader } from '@/components/header/UserProfileHeader';
import { MobileHeader } from '@/components/header/MobileHeader';

export function SidebarLayout({ children }: { children: React.ReactNode }) {
  const { user, isProUser } = useUser();
  const [commandDialogOpen, setCommandDialogOpen] = useState(false);

  // Keyboard shortcut for opening chat history search (Cmd+K or Ctrl+K)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setCommandDialogOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      <AppSidebar
        chatId={null}
        selectedVisibilityType="private"
        onVisibilityChange={() => {}}
        user={user || null}
        isProUser={isProUser}
        onHistoryClick={() => setCommandDialogOpen(true)}
      />
      <SidebarInset>
        {/* Desktop: profile in top-right */}
        <div className="hidden md:block fixed top-0 right-0 z-30 p-3">
          <UserProfileHeader />
        </div>
        {/* Mobile: unified header */}
        <MobileHeader hasActiveChat={false} />
        {children}
      </SidebarInset>

      {/* Advanced search dialog (Ctrl+K) */}
      <ChatHistoryDialog
        open={commandDialogOpen}
        onOpenChange={setCommandDialogOpen}
        user={user ?? null}
      />
    </>
  );
}
